import React from 'react';

export const ItemPerPagePickerDashboard: React.FunctionComponent<{
    onChange: (number: number) => void;
    defaultItemPerPage?: number;
    isAllowAll?: boolean;
}> = function ({ onChange, defaultItemPerPage = 3, isAllowAll = true }) {

    const onItemChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(+e.target.value);
    };

    const renderAllOption = () => {
        if(isAllowAll === true){
            return <option value={0}>All</option>
        }else{
            return <></>
        }
    }

    return (
        <div className="oa-pagination d-flex flex-row px-4">
            <div className="d-flex align-items-center px-2">
                <p className="m-0">Item Per Page</p>
            </div>
            <div className="d-flex align-items-center px-2">
                <select className="form-select" defaultValue={defaultItemPerPage} onChange={onItemChange}>
                    {renderAllOption()}
                    <option value={3}>3</option>
                    <option value={6}>6</option>
                    <option value={9}>9</option>
                    <option value={12}>12</option>
                </select>
            </div>
        </div>
    );
}